import { useEffect, useState } from "react";
import { ClockCounterClockwise } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth, hasRole } from "@/context/AuthContext";

// Aviso de fechas corridas por zona horaria (registros hechos después de las 5pm que cayeron en el día siguiente).
export default function TzDateFixBanner({ onFixed }) {
  const { user } = useAuth();
  const [audit, setAudit] = useState(null);
  const [busy, setBusy] = useState(false);
  const isAdmin = hasRole(user, "super_admin");

  useEffect(() => {
    if (!isAdmin) return;
    api.get("/admin/tz-date-audit").then((r) => setAudit(r.data)).catch(() => {});
  }, [isAdmin]);

  if (!isAdmin || !audit || (audit.expenses === 0 && audit.sales === 0)) return null;
  const total = audit.expenses + audit.sales;
  const parts = [audit.expenses > 0 && `${audit.expenses} gasto${audit.expenses === 1 ? "" : "s"}`, audit.sales > 0 && `${audit.sales} venta${audit.sales === 1 ? "" : "s"}`].filter(Boolean).join(" y ");
  const plural = (n, s) => `${n} ${s}${n === 1 ? "" : "s"}`;

  const fix = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/tz-date-fix");
      toast.success(`Fechas corregidas: ${plural(data.expenses, "gasto")}, ${plural(data.sales, "venta")}`);
      setAudit({ expenses: 0, sales: 0 });
      onFixed?.();
    } catch (err) { toast.error(err?.response?.data?.detail || "No se pudo corregir"); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex items-center justify-between gap-3 flex-wrap border border-amber-300 bg-amber-50 px-4 py-3 text-sm" data-testid="tz-fix-banner">
      <div className="inline-flex items-start gap-2 text-amber-900">
        <ClockCounterClockwise size={18} weight="duotone" className="shrink-0 mt-0.5" />
        <span><b>{parts}</b> {total === 1 ? "quedó" : "quedaron"} con la fecha del día siguiente (se {total === 1 ? "registró" : "registraron"} después de las 5 pm y el sistema usaba hora UTC). Ya está corregido para registros nuevos; corrige los existentes con un clic.</span>
      </div>
      <button type="button" onClick={fix} disabled={busy} className="h-8 px-3 rounded-sm bg-amber-600 hover:bg-amber-700 text-white text-xs font-semibold disabled:opacity-50" data-testid="tz-fix-apply">{busy ? "Corrigiendo…" : "Corregir fechas"}</button>
    </div>
  );
}
